import axios from 'axios'
// import router from '../router'
// import store from '../store'

/*
 * CSRF-TOKEN取得
 */
const getCsrfToken = (): any => {
  const csrf = document.querySelector('meta[name="csrf-token"]')

  if (!csrf) return false

  return csrf.getAttribute('content')
}

/*
 * @param target
 * APIの接続先 (app|cms)
 * appの時はcsrf-tokenを付与
 *
 * @param contentType
 * APIの呼び出しがどの範囲のコンテンツか (page|block|action)
 *
 * @return axiosのインスタンスを返却
 */

export const axiosSetting = (
  target: 'app' | 'cms',
  contentType: 'page' | 'block' | 'action',
  baseUrl?: string
) => {
  const setting: any = {
    timeout: 30000
  }

  // console.log(store)

  if (target === 'app') {
    const token = getCsrfToken()
    setting.headers = { 'X-CSRF-TOKEN': token }
  }

  if (target === 'cms') {
    setting.baseURL = `${process.env.VUE_APP_WPAPI_URL}/wp-json/wp/v2/`
    setting.auth = {
      username: process.env.VUE_APP_WPAPI_USER,
      password: process.env.VUE_APP_WPAPI_PASS
    }
  }
  if (baseUrl) setting.baseURL = baseUrl

  const instance = axios.create(setting)

  instance.interceptors.response.use(
    (response) => {
      // リクエスト成功時の共通処理を入れる
      return response
    },
    (error) => {
      // リクエスト失敗時の共通処理を入れる
      console.log(error)
      console.log(error.response)

      // @TODO 下記解決したら共通でエラー処理を挟むようにする
      // store / routerを使おうとするとエラーになるので各処理で書くように変更する

      // if (contentType === 'page' && error.response.status === 404) {
      //   console.log('404を表示する処理')
      // }

      // if (contentType === 'action') {
      //   store.commit('showSystemError', 'modal')
      // }

      return Promise.reject(error)
    }
  )

  return instance
}
